import tracking from '@common/tracking';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FullScreenLoader } from '../../common/components/FullScreenLoader';
import { useSignUpModel } from '../models/SignUpModel';
import { SignUpEmailPage } from '../views/pages/SignUpEmailPage';
import { SignUpNamePage } from '../views/pages/SignUpNamePage';
import { SignUpPartnerPage } from '../views/pages/SignUpPartnerPage';
import { SignUpPasswordPage } from '../views/pages/SignUpPasswordPage';
import { SignUpPhoneNumberPage } from '../views/pages/SignUpPhoneNumberPage';
import { SignUpSuccessPage } from '../views/pages/SignUpSuccessPage';
import { SignUpVerifyCodePage } from '../views/pages/SignUpVerifyCodePage';

export const SignUpController: React.FC = () => {
  const signUpModel = useSignUpModel();
  const [params] = useSearchParams();

  const init = async () => {
    await signUpModel.init(params);
  };

  useEffect(() => {
    init();
  }, []);

  switch (signUpModel.page) {
    case 'EMAIL':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupEmailForm',
      });
      return <SignUpEmailPage />;
    case 'PARTNER':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupPartnerWelcome',
      });
      return <SignUpPartnerPage />;
    case 'PASSWORD':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupPasswordForm',
      });
      return <SignUpPasswordPage />;
    case 'PHONE':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupPhoneForm',
      });
      return <SignUpPhoneNumberPage />;
    case 'NAME':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupNameForm',
      });
      return <SignUpNamePage />;
    case 'CODE':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupPhoneVerificationCodeForm',
      });
      return <SignUpVerifyCodePage />;
    case 'FINISH':
      tracking.track({
        action: 'Web Component Viewed',
        view: 'SignupSuccessMessage',
      });
      return <SignUpSuccessPage />;
    case 'LOADING':
      return <FullScreenLoader />;
    default:
      return <SignUpEmailPage />;
  }
};
